<div class="modal-body p-0">
    <div class="modal-content bg-transparent">
        <img src="./assets/img/simyo-banner-1gb.jpg" alt="Simyo" class="img-fluid" (click)="activeModal.dismiss('Cross click')" />
    </div>
</div>
